import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ImageViewer from "react-simple-image-viewer";

import { LazyLoadImage } from "react-lazy-load-image-component";
import { IMAGE_QUALITY } from "../../utils/utils";
import { fireGtmEvent } from "../../utils/googleAnalytics";

const HotelImageCarousel = ({
  name,
  hotelImages,
  address,
  isAddon = false,
}) => {
  const [viewImage, setViewImage] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleImage = (id) => {
    setViewImage(true);
    setCurrentIndex(id);
  };

  return (
    <div>
      <Carousel
        infiniteLoop
        showStatus={!viewImage}
        showThumbs={false}
        showArrows={!viewImage}
        showIndicators={false}
        autoPlay={false}
        onClickItem={(id) => {
          handleImage(id);
          isAddon
            ? fireGtmEvent("addon_image_expanded")
            : fireGtmEvent("hotel_image_expanded");
        }}
        className="mainpage__headerImages"
      >
        {hotelImages?.map((image, id) => (
          <img
            key={id}
            width={
              window.location.href.includes("room/checkout")
                ? "fit-content"
                : "300px"
            }
            height="300px"
            style={{ objectFit: "cover" }}
            loading={id === 0 ? "eager" : "lazy"}
            src={
              image?.cdnImageUrl +
              `?tr=w-375,ar-1-1,h-300,q-${IMAGE_QUALITY},fo-auto`
            }
            alt={name + "'s Hotel Image in " + address}
          />
        ))}
      </Carousel>
      {viewImage && (
        <ImageViewer
          src={hotelImages?.map((img) => {
            return img.cdnImageUrl;
            // +
            // `?tr=w-600,ar-1-1,h-300,q-${IMAGE_QUALITY},fo-auto`
            // return img.cdnImageUrl + "?tr=w-auto-720,ar-1-1,h-600,q-80";
          })}
          currentIndex={currentIndex}
          disableScroll={false}
          closeOnClickOutside={true}
          onClose={setViewImage}
        />
      )}
    </div>
  );
};

export default HotelImageCarousel;
